import { render } from "./CreateRoomRestrictionForm.vue?vue&type=template&id=c69538d8"
import script from "./CreateRoomRestrictionForm.vue?vue&type=script&lang=js"
export * from "./CreateRoomRestrictionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__